import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import CareIllustration from '../components/CareIllustration';
import './LoginChoice.css';

function CareCanvas() {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame, start, width, height;
    function draw(time = 0) {
      start ??= time;
      const progress = motion.matches ? 0 : Math.min((time - start) / 1000, 5);
      ctx.clearRect(0, 0, width, height);
      for (let line = 0; line < 7; line++) {
        ctx.beginPath();
        for (let x = 0; x <= width; x += 8) {
          const y = height * .5 + Math.sin(x / 240 + progress * .16 + line * .35) * height * .3 + line * 24;
          x ? ctx.lineTo(x, y) : ctx.moveTo(x, y);
        }
        ctx.strokeStyle = 'rgba(10,110,189,0.065)';
        ctx.lineWidth = 1;
        ctx.stroke();
      }
      if (!motion.matches && progress < 5 && !document.hidden) frame = requestAnimationFrame(draw);
    }
    function resize() {
      cancelAnimationFrame(frame);
      const bounds = canvas.getBoundingClientRect();
      width = bounds.width; height = bounds.height;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = width * ratio; canvas.height = height * ratio;
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      start = undefined;
      draw(performance.now());
    }
    const observer = new ResizeObserver(resize);
    observer.observe(canvas);
    motion.addEventListener('change', resize);
    function visibility() { if (document.hidden) cancelAnimationFrame(frame); else resize(); }
    document.addEventListener('visibilitychange', visibility);
    return () => { cancelAnimationFrame(frame); observer.disconnect(); motion.removeEventListener('change', resize); document.removeEventListener('visibilitychange', visibility); };
  }, []);
  return <canvas ref={ref} className="nc-login-canvas" aria-hidden="true" />;
}

export default function LoginChoice() {
  return <main id="main-content" className="nc-login-page">
    <CareCanvas />
    <div className="container nc-login-content">
      <header className="nc-login-heading">
        <p className="nc-eyebrow">YOUR NEPHROCORE ACCOUNT</p>
        <h1>Connected care.<br /><em>Starts with you.</em></h1>
        <p>One place for your health, your practice, and the people who care.</p>
      </header>
      <div className="nc-login-choices">
        <section className="nc-login-card">
          <div className="nc-login-art"><CareIllustration kind="consult" /><span>YOUR HEALTH, TOGETHER</span></div>
          <div className="nc-login-card-body"><h2>I’m a patient</h2><p>Find your specialist, book tests and keep your care in one place.</p><div className="nc-login-features"><span>Appointments</span><span>Health records</span><span>Memberships</span></div><Link className="nc-button" to="/patient/sign-in">Patient login <svg className="nc-login-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14m-6-6 6 6-6 6" /></svg></Link></div>
        </section>
        <section className="nc-login-card">
          <div className="nc-login-art"><CareIllustration kind="doctor" /><span>YOUR PRACTICE, CONNECTED</span></div>
          <div className="nc-login-card-body"><h2>I’m a doctor</h2><p>Make room for better care. Manage your practice and stay close to patients.</p><div className="nc-login-features"><span>Appointments</span><span>Availability</span><span>Patient care</span></div><Link className="nc-button" to="/doctor/sign-in">Doctor login <svg className="nc-login-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14m-6-6 6 6-6 6" /></svg></Link></div>
        </section>
      </div>
      <p className="nc-login-help">A little help getting started? <Link to="/contact">Talk to our care team <span aria-hidden="true">→</span></Link></p>
    </div>
  </main>;
}
